import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { Button, CircularProgress, Grid, IconButton, Link, makeStyles, Tooltip, Typography } from "@material-ui/core";
import { Autorenew, Search } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "features/client/styles";
import { emptyString } from "constants/defaultValues";

const useStyles = makeStyles(clientPageStyle);

function BasicFilters({ setExtended, filterLens, onReset, onSearch, loading }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleExtended = useCallback(() => {
    setExtended(true);
  }, [setExtended]);

  return (
    <>
      <Grid container>
        <Grid item>
          <Typography>{t("Client.EnterCompanyNameAndCity")}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <CustomTextField
              fullWidth
              label={t("Client.CompanyName")}
              value={(filterLens.companyName |> get) || emptyString}
              onChange={filterLens.companyName |> set |> onTextBoxChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <CustomTextField
              fullWidth
              label={t("Client.City")}
              value={(filterLens.city |> get) || emptyString}
              onChange={filterLens.city |> set |> onTextBoxChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <CustomTextField
              fullWidth
              label={t("Client.State")}
              value={(filterLens.state |> get) || emptyString}
              onChange={filterLens.state |> set |> onTextBoxChange}
            />
          </Grid>

          <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
            <IconButton color="default" onClick={onReset} style={{ marginRight: 10 }}>
              <Tooltip title={t("General.ResetFilter")}>
                <Autorenew fontSize="small" />
              </Tooltip>
            </IconButton>
            <Button
              id="clientSearch_SearchBtn"
              right="true"
              variant="contained"
              color="primary"
              onClick={onSearch}
              endIcon={loading ? <CircularProgress size={20} color={"inherit"} /> : <Search />}
            >
              {t("General.Search")}
            </Button>
          </Grid>
          <Grid item container>
            <Link
              id="clientSearch_extendedSearch"
              underline="always"
              color="primary"
              onClick={handleExtended}
              className={classes.cursorLink}
            >
              {t("Client.ExtendedSearch")}
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

BasicFilters.propTypes = {
  setExtended: PropTypes.func.isRequired,
  filterLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default BasicFilters;
